import { Icon } from "@mui/material";
import { FavoriteBorder, Reply } from "@mui/icons-material";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import BookmarkBorderTwoToneIcon from "@mui/icons-material/BookmarkBorderTwoTone";
import ShareTwoToneIcon from "@mui/icons-material/ShareTwoTone";
import AdvertisementCard from "components/cards/AdvertisementCard";
import TipsCard from "components/cards/TipsCard";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import tipsService from "../../services/TipsService";
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";
import { get, set } from "lodash";
import SectionFotos from "components/fotos/SectionFotos";
import Comments from "components/comments/comments";
import Contact from "components/contact/contact";
import avatarPlaceHolder from "data/avatars/avatar.jpg";


import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTiktok,
  FaYoutube,
} from "react-icons/fa";

const TipsDetails: React.FC = () => {
  const { dicaId }: any = useParams();
  const navigate = useNavigate();


  const [dica, setDica] = useState<any>();
  const [loading, setLoading] = useState(true);

  const [dicas, setDicas] = useState([]);
  const [banner, setBanner] = useState("");
  const [nameCategoriaSelected, setNameCategoriaSelected] = useState("");

  useEffect(() => {
    getDicaDetails();

  }, [dicaId]);

  

  const getUrl = (url: any) => {
    if (url.includes("http")) {
      return url;
    } else {
      return "https://" + url;
    }
  }

  const getDicaDetails = async () => {
    await tipsService
      .getTipsDetail(dicaId)
      .then((response: any) => {
        setNameCategoriaSelected(response.data.category.name);
        setBanner(
          process.env.REACT_APP_BACKEND_API_URL +
            "/storage/images/categories/banners/" +
            response.data.category.banner_path
        );
        setDica(response.data);
        getDicas(response.data.category_id);
        // setDicas(response.data);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false); // end loading
      });
  };

  const getDicas = async (category_id: any) => {
    setLoading(true); // start loading
    await tipsService
      // .getTips(category_id, null, "")
      .getMoreTips(dicaId)
      .then((response: any) => {

        // // separando 8 dicas randomicas
        // let dicasTmp = response.data;
        // dicasTmp = dicasTmp.sort(() => Math.random() - 0.5);
        // dicasTmp = dicasTmp.slice(0, 8);

        setDicas(response);
        setLoading(false); // end loading
      })
      .catch((error: any) => {
        setLoading(false); // end loading
        console.error(error);
      });
  };

  const listarDicas = () => {
    return dicas.map((dica: any) => {
      const urlBase: any =
        process.env.REACT_APP_BACKEND_API_URL + "/storage/users";
      const ImageUrl: any = urlBase + `/${dica.post.user.avatar_path}`;
      
      return (
        <div className="p-1" style={{ cursor: 'pointer'}} onClick={() => {navigate('/dicas-detalhes/' + dica.id)}}>
          <TipsCard
            categoria={dica.category.name}
            adImg={
              process.env.REACT_APP_BACKEND_API_URL +
              "/storage/images/posts/tips/banners/" +
              dica.banner_path
            }
            adTitle={dica.name}
            likeCount={dica.likes_count}
            commentsCount={dica.comments_count}
            authorImg={ImageUrl}
            authorName={dica.post.user.display_name}
            adDate={format(parseISO(dica.created_at), "d 'de' MMMM, yyyy", {
              locale: ptBR,
            })}
          />
        </div>
      );
    });
  };

  return (
    
      <div className="">
      { loading ? (
          <div className="my-60 spinner border-primary-600"></div>
        ) : (
          <>
            {
              !dica ? (
                <div className="flex justify-center items-center p-10">
                  <div className="bg-primary-200 border shadow rounded-3xl w-100 p-8">
                    Nenhuma dica encontrada
                  </div>
                </div>
              ) : (
                <>
                  <section>
                    <div className="flex mx-4 md:mx-[16vw] mt-8">
                        <div
                          style={{ backgroundImage: `url(${banner})` }}
                          className="flex mb-2 justify-center w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] h-96 bg-cover rounded-3xl bg-blend-darken bg-center"
                        >   
                          <div className="flex px-4 md:px-4 bg-black bg-opacity-50 w-full justify-center font-semibold text-3xl md:text-5xl py-44 brightness-100 text-white rounded-3xl">
                            {nameCategoriaSelected}
                          </div> 
                        </div>
                    </div>

                    <div className="flex flex-col mx-4 md:mx-[16vw] mt-2">

                        <div className="flex-row">
                          <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
                            <Link to={"/"}>Home</Link> &gt;{" "}
                            <Link to={"/dicas-geral"}>Dicas</Link>&gt;{" "}
                            <Link to={""}> {dica.name}</Link>
                          </span>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-3 mt-4 gap-5">

                          <div className="col-span-1 md:col-span-2">
                            <div className="flex-row mt-6">
                              <span className="bg-primary-600 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-slate-700 cursor-pointer">
                                {dica.category.name}
                              </span>
                              <span className="bg-primary-400 text-white text-xs font-medium me-2 px-5 py-0.5 rounded-full dark:bg-slate-700">
                                {dica.subcategory.name}
                              </span>
                            </div>

                            <div className="flex my-5">
                              <span className="text-4xl font-bold">{dica.name}</span>
                            </div>

                            <div className="flex my-5">
                              <span
                                className="text-lg text-gray-400"
                                dangerouslySetInnerHTML={{ __html: dica.description }}
                              ></span>
                            </div>


                            <div className="flex">

                              <div className="flex rounded-full items-center">

                                <div className="rounded-full w-12 object-cover">
                                  <img
                                    alt=""
                                    className="rounded-full w-[2.5rem] h-[2.5rem] object-cover"
                                    src={
                                      process.env.REACT_APP_BACKEND_API_URL +
                                      "/storage/users/" +
                                      dica.post.user.avatar_path
                                    }
                                    onError={(e : any) => {
                                      e.target.onerror = null;
                                      e.target.src = avatarPlaceHolder;
                                    }}
                                  ></img>
                                </div>

                                <div className="mx-2 items-center">
                                  <div className="flex items-center">
                                    <div className="flex-col items-center">
                                      <div className="">
                                        <div>
                                          <span className="text-gray-600 font-medium mb-[-18px]">
                                            {dica.post.user.display_name}
                                          </span>
                                        </div>
                                        <div>
                                          <span className=" text-gray-400">
                                            {" "}
                                            {format(
                                              parseISO(dica.created_at),
                                              "d 'de' MMMM, yyyy",
                                              { locale: ptBR }
                                            )}
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="flex items-center gap-4 ms-4">
                                <div>
                                  <Icon
                                    component={FavoriteBorder}
                                    fontSize="small"
                                    className="mr-2"
                                  />
                                </div>
                                <div>
                                  <Icon
                                    component={SmsOutlinedIcon}
                                    fontSize="small"
                                    className="mr-2 text-primary-500"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>


                          <div className="flex flex-col items-end">
                            
                            <div className="flex">
                              {dica.facebook && (
                                <a href={getUrl(dica.facebook)} target="_blank" rel="noreferrer">
                                  <div className="p-0-25 click">
                                    <FaFacebookSquare size={30} />
                                  </div>
                                </a>
                              )}

                              {dica.instagram && (
                                <a href={getUrl(dica.instagram)} target="_blank" rel="noreferrer">
                                  <div className="p-0-25 click">
                                    <FaInstagramSquare size={30} />
                                  </div>
                                </a>
                              )}

                              {dica.tiktok && (
                                <a href={getUrl(dica.tiktok)} target="_blank" rel="noreferrer">
                                  <div className="p-0-25 click">
                                    <FaTiktok size={30} />
                                  </div>
                                </a>
                              )}

                              {dica.youtube && (
                                <a href={getUrl(dica.youtube)} target="_blank" rel="noreferrer">
                                  <div className="p-0-25 click">
                                    <FaYoutube size={30} />
                                  </div>
                                </a>
                              )}

                              {dica.linkedin && (
                                <a href={getUrl(dica.linkedin)} target="_blank" rel="noreferrer">
                                  <div className="p-0-25 click">
                                    <FaLinkedin size={30} />
                                  </div>
                                </a>
                              )}
                            </div>

                            {dica.url_video && (
                              <div className="w-full h-[12rem] sm:h-[20rem] md:h-[23rem] lg:h-[16rem] border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl border-8 overflow-hidden">
                                <iframe
                                  width="100%"
                                  height="100%"
                                  src={dica.url_video}
                                  title="YouTube video player"
                                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                ></iframe>
                              </div>
                            )}

                            <div className="mt-4" style={{ textAlign: "right" }}>
                              <b>Contato</b>
                              <p>{dica?.phone}</p>
                              <p>{dica?.email}</p>
                            </div>

                            {dica?.address?.address != null ? (
                              <div className="mt-4" style={{ textAlign: "right" }}>
                                <b>Endereço</b>
                                <p>{dica?.address?.address}</p>
                                <p>
                                  {dica?.address?.city} - {dica?.address?.country} -{" "}
                                  {dica?.address?.state} - {dica?.address?.postal_code}
                                </p>
                              </div>
                            ) : null}

                          </div>

                        </div>

                        {dica.attachments.length > 0 && (
                          <div className="flex justify-center mt-10 w-full">
                            <SectionFotos
                              attachments={dica.attachments}
                              className="w-full"
                              url="/storage/images/posts/tips/attachments/"
                            />
                          </div>
                        )}
                    </div>

                    <div>
                      <Comments
                        dados={dica}
                        tela="dica"
                        url="/posts/tips/comment"
                        urlAnswer="/posts/tips/answer"
                        get={getDicaDetails}
                      />
                    </div>

                    <div className=" mx-4 md:mx-[16vw] mt-24">
                      <div>
                        <span className="text-3xl font-bold text-primary-600">
                          Mais Dicas Radar
                        </span>
                      </div>
                      <div className=" flex justify-center flex-wrap gap-3 mb-10 mt-4">
                        {listarDicas()}
                      </div>
                    </div>
                    
                  </section>
                </>
              )
            }
          </>
        )
      }
    </div>

  );
};

export default TipsDetails;
